import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'

Vue.use(VueRouter)

// 解决 Vue Router 3 中 NavigationDuplicated / Redirected / Cancelled 报错
var originalPush = VueRouter.prototype.push
var originalReplace = VueRouter.prototype.replace
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(function(err) { return err })
}
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(function(err) { return err })
}

// 所有角色都能看到的路由
export var constantRoutes = [
  {
    path: '/login',
    component: function() { return import('@/views/login/index.vue') },
    hidden: true
  }
]

// 需要根据权限动态加载的路由
export var asyncRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: function() { return import('@/views/dashboard/index.vue') },
        meta: { title: '控制台', icon: 'el-icon-s-home', permissions: ['dashboard:view'] }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    meta: { permissions: ['user:view'] },
    children: [
      {
        path: 'list',
        name: 'UserList',
        component: function() { return import('@/views/user/index.vue') },
        meta: { title: '用户管理', icon: 'el-icon-user', permissions: ['user:view'] }
      }
    ]
  },
  {
    path: '/device',
    component: Layout,
    meta: { permissions: ['device:view'] },
    children: [
      {
        path: 'list',
        name: 'DeviceList',
        component: function() { return import('@/views/device/index.vue') },
        meta: { title: '设备管理', icon: 'el-icon-mobile-phone', permissions: ['device:view'] }
      }
    ]
  },
  {
    path: '/order',
    component: Layout,
    meta: { title: '订单管理', icon: 'el-icon-s-order', permissions: ['order:view'] },
    children: [
      {
        path: 'points',
        name: 'PointsOrderList',
        component: function() { return import('@/views/order/points.vue') },
        meta: { title: '积分订单', icon: 'el-icon-star-off', permissions: ['order:view'] }
      },
      {
        path: 'balance',
        name: 'BalanceOrderList',
        component: function() { return import('@/views/order/balance.vue') },
        meta: { title: '算力券订单', icon: 'el-icon-wallet', permissions: ['order:view'] }
      }
    ]
  },
  {
    path: '/product',
    component: Layout,
    meta: { permissions: ['product:view'] },
    children: [
      {
        path: 'list',
        name: 'ProductList',
        component: function() { return import('@/views/product/index.vue') },
        meta: { title: '商品管理', icon: 'el-icon-goods', permissions: ['product:view'] }
      }
    ]
  },
  {
    path: '/withdraw',
    component: Layout,
    meta: { permissions: ['withdraw:view'] },
    children: [
      {
        path: 'list',
        name: 'WithdrawList',
        component: function() { return import('@/views/withdraw/index.vue') },
        meta: { title: '提现管理', icon: 'el-icon-wallet', permissions: ['withdraw:view'] }
      }
    ]
  },
  {
    path: '/points-exchange',
    component: Layout,
    meta: { permissions: ['exchange:view'] },
    children: [
      {
        path: 'index',
        name: 'PointsExchange',
        component: function() { return import('@/views/points-exchange/records.vue') },
        meta: { title: '积分兑换', icon: 'el-icon-s-check', permissions: ['exchange:view'] }
      }
    ]
  },
  {
    path: '/finance',
    component: Layout,
    meta: { title: '财务管理', icon: 'el-icon-money', permissions: ['finance:flow', 'finance:statistics'] },
    children: [
      {
        path: 'flow',
        name: 'FinanceFlow',
        component: function() { return import('@/views/finance/flow.vue') },
        meta: { title: '收支流水', icon: 'el-icon-notebook-2', permissions: ['finance:flow'] }
      },
      {
        path: 'statistics',
        name: 'FinanceStats',
        component: function() { return import('@/views/finance/statistics.vue') },
        meta: { title: '统计报表', icon: 'el-icon-data-analysis', permissions: ['finance:statistics'] }
      }
    ]
  },
  {
    path: '/revenue',
    component: Layout,
    meta: { title: '收益管理', icon: 'el-icon-coin', permissions: ['revenue:dividend', 'revenue:settlement', 'revenue:balance', 'revenue:points'] },
    children: [
      {
        path: 'dividend',
        name: 'Dividend',
        component: function() { return import('@/views/finance/dividend.vue') },
        meta: { title: '分红发放', icon: 'el-icon-present', permissions: ['revenue:dividend'] }
      },
      {
        path: 'settlement',
        name: 'Settlement',
        component: function() { return import('@/views/finance/settlement.vue') },
        meta: { title: '收益结算', icon: 'el-icon-s-finance', permissions: ['revenue:settlement'] }
      },
      {
        path: 'balance',
        name: 'BalanceAdjust',
        component: function() { return import('@/views/finance/balance.vue') },
        meta: { title: '算力券调整', icon: 'el-icon-wallet', permissions: ['revenue:balance'] }
      },
      {
        path: 'points',
        name: 'PointsAdjust',
        component: function() { return import('@/views/finance/points.vue') },
        meta: { title: '积分调整', icon: 'el-icon-star-off', permissions: ['revenue:points'] }
      }
    ]
  },
  {
    path: '/content',
    component: Layout,
    meta: { title: '内容管理', icon: 'el-icon-document', permissions: ['announcement:view', 'banner:view', 'project:view', 'about:view'] },
    children: [
      {
        path: 'announcement',
        name: 'Announcement',
        component: function() { return import('@/views/content/announcement.vue') },
        meta: { title: '公告管理', icon: 'el-icon-bell', permissions: ['announcement:view'] }
      },
      {
        path: 'banner',
        name: 'Banner',
        component: function() { return import('@/views/content/banner.vue') },
        meta: { title: 'Banner管理', icon: 'el-icon-picture', permissions: ['banner:view'] }
      },
      {
        path: 'project',
        name: 'ProjectManage',
        component: function() { return import('@/views/content/project.vue') },
        meta: { title: '项目管理', icon: 'el-icon-folder-opened', permissions: ['project:view'] }
      },
      {
        path: 'about',
        name: 'AboutManage',
        component: function() { return import('@/views/content/about.vue') },
        meta: { title: '关于我们', icon: 'el-icon-office-building', permissions: ['about:view'] }
      }
    ]
  },
  {
    path: '/system',
    component: Layout,
    meta: { title: '系统管理', icon: 'el-icon-setting', permissions: ['staff:view', 'role:view', 'config:view', 'config:edit', 'log:view'] },
    children: [
      {
        path: 'staff',
        name: 'StaffList',
        component: function() { return import('@/views/staff/index.vue') },
        meta: { title: '员工管理', icon: 'el-icon-s-custom', permissions: ['staff:view'] }
      },
      {
        path: 'role',
        name: 'RoleList',
        component: function() { return import('@/views/system/role.vue') },
        meta: { title: '角色管理', icon: 'el-icon-s-check', permissions: ['role:view'] }
      },
      {
        path: 'config',
        name: 'Config',
        component: function() { return import('@/views/config/index.vue') },
        meta: { title: '系统配置', icon: 'el-icon-s-tools', permissions: ['config:view'] }
      },
      {
        path: 'update',
        name: 'AppUpdate',
        component: function() { return import('@/views/system/update.vue') },
        meta: { title: '版本更新', icon: 'el-icon-upload2', permissions: ['config:edit'] }
      },
      {
        path: 'log',
        name: 'OperationLog',
        component: function() { return import('@/views/system/log.vue') },
        meta: { title: '操作日志', icon: 'el-icon-document-copy', permissions: ['log:view'] }
      },
      {
        path: 'copyright-log',
        name: 'CopyrightLog',
        component: function() { return import('@/views/system/copyright-log.vue') },
        meta: { title: '版权日志', icon: 'el-icon-tickets', permissions: ['log:view'] }
      }
    ]
  },
  {
    path: '*',
    redirect: '/dashboard',
    hidden: true
  }
]

var createRouter = function() {
  return new VueRouter({
    routes: constantRoutes
  })
}

var router = createRouter()

export function resetRouter() {
  var newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router
